import { useCheckBreakpoint } from './useCheckBreakpoint';

export const useMatchByBreakpointIndex =
  (): PrimedMatchByBreakpointIndexReturn => {
    const currentBreakpoint = useCheckBreakpoint();

    return usePrimedMatchByBreakpointIndex(currentBreakpoint);
  };

export const usePrimedMatchByBreakpointIndex = (
  currentBreakpoint: CurrentBreakpoint,
) => {
  return <T>(valueArray: readonly T[]): T => {
    const {
      0: mobileVal,
      1: tabletVal,
      2: desktopVal,
      3: largeDisplayVal,
      length,
    } = valueArray;
    const lastAvailableVal = valueArray[length - 1];

    if (currentBreakpoint.isMobile) return mobileVal;

    if (currentBreakpoint.isTablet) return tabletVal ?? lastAvailableVal;

    if (currentBreakpoint.isDesktop) return desktopVal ?? lastAvailableVal;

    if (currentBreakpoint.isLargeDisplay)
      return largeDisplayVal ?? lastAvailableVal;

    return mobileVal;
  };
};

type CurrentBreakpoint = ReturnType<typeof useCheckBreakpoint>;
type PrimedMatchByBreakpointIndexReturn = ReturnType<
  typeof usePrimedMatchByBreakpointIndex
>;
